import { Instance, SnapshotOut, types } from 'mobx-state-tree';
import { withEnvironment } from '../extensions/with-environment';
import { withRootStore } from '../extensions/with-root-store';
import { withPagination } from '../extensions/withPagination';
import { withSetPropAction } from '../extensions/withSetPropAction';
import { IMedicalDeviceInfo, MedicalDeviceInfo } from '../medical-device-info/MedicalDeviceInfo';

import { MedicalDeviceInfoApi } from '../../services/medical-device-info/MedicalDeviceInfo';

import { TGetMedicalDeviceInfoResult } from '../../services/medical-device-info/MedicalDeviceInfoTypes';

/**
 * # MedicalDeviceInfoStore
 *
 * MedicalDeviceInfoStore을 설명하세요.
 */
export const MedicalDeviceInfoStore = types
  .model('MedicalDeviceInfoStore')
  // --------------------------------------------------------------------------
  .props({
    medicalDeviceInfoList: types.optional(types.array(MedicalDeviceInfo), []),
    medicalDeviceInfo: types.optional(MedicalDeviceInfo, {}),
    authYn: types.maybeNull(types.optional(types.boolean, false)),
  })
  .extend(withEnvironment)
  .extend(withRootStore)
  .extend(withPagination)
  .actions(withSetPropAction)
  // eslint-disable-line @typescript-eslint/no-unused-vars
  .views((self) => ({}))
  // --------------------------------------------------------------------------
  // MUTATEs - 모델 상태를 변경
  .actions((self) => ({
    /**
     * medicalDeviceInfos을 교체
     *
     * @param `medicalDeviceInfos` 새로운 모델의 배열
     */
    setMedicalDeviceInfo: (medicalDeviceInfo: IMedicalDeviceInfo) => {
      self.medicalDeviceInfo = medicalDeviceInfo;
    },
  }))
  // --------------------------------------------------------------------------
  // REQUESTs - 서비스 요청 및 기타 인터페이스 요청
  .actions((self) => ({
    /**
     * 전체 목록을 Api를 통해 조회
     *
     * 조회한 결과로 MedicalDeviceInfos를 교체한다. 실패시 에러 로그를 남긴다.
     */

    get: async () => {
      try {
        const medicalDeviceInfoApi: MedicalDeviceInfoApi = new MedicalDeviceInfoApi(
          self.environment.api,
        );
        const result: TGetMedicalDeviceInfoResult = await medicalDeviceInfoApi.get();

        if (self.rootStore.responseStore.getResponseResult(result)) {
          if (result.medicalDeviceInfo) {
            self.setMedicalDeviceInfo(result.medicalDeviceInfo);
          }
        }
      } catch (e) {
        self.rootStore.responseStore.errorProcessing(e);
      }
    },
  }));

// --------------------------------------------------------------------------
type TMedicalDeviceInfoStore = Instance<typeof MedicalDeviceInfoStore>;
type TMedicalDeviceInfoStoreSnapshot = SnapshotOut<typeof MedicalDeviceInfoStore>;

export interface IMedicalDeviceInfoStore extends TMedicalDeviceInfoStore {}
export type TMedicalDeviceInfoStoreKeys = keyof TMedicalDeviceInfoStoreSnapshot & string;
export interface IMedicalDeviceInfoStoreSnapshot extends TMedicalDeviceInfoStoreSnapshot {}
export const createMedicalDeviceInfoStore = () =>
  types.optional(MedicalDeviceInfoStore, {} as TMedicalDeviceInfoStore);
